import React from "react";
import { Box } from "@origin-digital/ods-core";
import { DraftsTable } from "src/components/Drafts";

export const ContentSection = () => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      data-id="contentSection.root"
    >
      <DraftsTable />
    </Box>
  );
};
